import { positionOpts } from './common'

// 图例信息
export const tooltipDefault = {
  tooltipVisible: true,
  tooltipPosition: 'bottom',
  tooltipShowTitle: false,
  tooltipEnterable: false,
  tooltipShowContent: true
}
export const tooltipConfig = [
  {
    info: {
      title: '提示（Tooltip）',
      icon: 'icon-setting'
    },
    fields: [
      { title: '显示提示', name: 'tooltipVisible', description: '设置是否显示', type: 'switch' },
      {
        title: '提示位置',
        name: 'tooltipPosition',
        description: '',
        type: 'select',
        options: positionOpts(['top', 'bottom', 'left', 'right']),
        visible: ({ tooltipVisible }) => tooltipVisible === true
      },
      {
        title: '显示Title',
        name: 'tooltipShowTitle',
        description: '',
        type: 'switch',
        visible: ({ tooltipVisible }) => tooltipVisible === true
      },
      {
        title: '鼠标滑入',
        name: 'tooltipEnterable',
        description: '',
        type: 'switch',
        visible: ({ tooltipVisible }) => tooltipVisible === true
      },
      {
        title: '展示内容框',
        name: 'tooltipShowContent',
        description: '',
        type: 'switch',
        visible: ({ tooltipVisible }) => tooltipVisible === true
      }
    ]
  }
]

export function calcTooltipData(options) {
  let calcData = {}
  if (options.tooltipVisible) {
    calcData = {
      shared: true,
      showMarkers: true,
      showCrosshairs: options.tooltipShowCrosshairs,
      crosshairs: {
        type: options.tooltipCrosshairsType
      }
    }
  } else {
    calcData = null
  }
  return calcData
}
